var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgCompleteSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 184,
    viewBox: "0 0 215 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000003519"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 32",
    cx: 88.1727,
    cy: 97.0448,
    r: 79.9755,
    fill: "#F6F1FC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000003518"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 223",
    d: "M8.87751 168.4L69.3895 45.8647C70.3935 43.8317 72.4667 42.5206 74.7304 42.6516C110.865 44.7425 138.916 77.1635 148.965 109.348C149.82 112.086 148.435 114.98 145.836 116.193L16.7396 176.438C11.6377 178.819 6.38461 173.448 8.87751 168.4Z",
    fill: "#7B35D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.201 125.889L99.9822 137.47C86.5718 133.31 53.9162 114.097 47.8281 89.3118L56.9032 71.1948C61.5932 90.4658 94.8748 121.319 125.201 125.889Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6583 109.89C39.139 126.695 54.0949 141.451 77.7907 147.918L61.2237 155.655C49.8374 153.667 31.5439 141.995 28.7764 127.809L37.6583 109.89Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.852 152.14L8.83486 168.404C6.34643 173.452 11.5988 178.817 16.6988 176.437L143.638 117.199L132.958 95.3604L16.852 152.14Z",
    fill: "#6F30BE",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 224",
    d: "M69.8545 46.9653C99.7062 51.6269 129.86 74.8891 143.649 117.084C114.652 108.714 78.059 79.8798 69.8545 46.9653Z",
    fill: "#7B35D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 225",
    d: "M141.571 103.989C128.734 72.5418 105.884 54.328 81.8089 48.3329C78.826 47.59 76.4666 50.5582 77.8117 53.3223C90.8278 80.0688 114.991 98.7675 136.803 108.609C139.837 109.978 142.829 107.071 141.571 103.989Z",
    fill: "#4A207F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.1506 82.9139C96.56 78.2135 94.8981 72.8961 94.4385 66.822C94.288 64.8334 95.7948 63.1203 97.7834 62.971C103.177 62.5658 108.138 62.9421 112.742 64.1883C103.115 56.3958 92.4929 51.1106 81.7573 48.3836C78.7779 47.6268 76.4207 50.5908 77.7688 53.3534C83.215 64.5139 90.6936 74.4227 99.1506 82.9139Z",
    fill: "#37185F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 233",
    d: "M125.685 93.2446C131.323 84.1661 154.024 64.7316 181.438 81.257C203.849 94.7662 175.49 114.575 168.908 98.0636C161.706 79.9992 194.412 62.8731 211.5 76.5166",
    stroke: "#D0ABFF",
    strokeWidth: 6.82696,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234",
    d: "M100.335 65.1113C122.046 38.163 132.153 0.236377 99.4939 4.15798",
    stroke: "#D0ABFF",
    strokeWidth: 6.82696,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 235",
    d: "M129.677 63.9848C137.198 66.4824 141.188 59.6126 138.57 52.6219C135.358 45.75 137.893 37.573 151.057 40.8696C164.22 44.1663 162.889 32.345 158.463 26.5672C153.066 19.5231 159.834 2.48705 177.173 13.4738",
    stroke: "#D0ABFF",
    strokeWidth: 6.82696,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 240",
    d: "M45.7319 164.989C36.4264 159.406 25.7212 149.439 20.6391 140.071L1.5455 168.647L12.1425 182.635L45.7319 164.989Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgCompleteSignup);
export default __webpack_public_path__ + "static/media/img_completeSignup.f13303723f25f538b15282f19c4c2ab9.svg";
export { ForwardRef as ReactComponent };